<template>
  <div :class="[$style.asideIcon, { [$style.asideIconBorder]: (!isPolicy || isPolicyIcon) }]">
    <Icon
      :class="[{
        [$style.iconPolicy]: (isPolicy && !isPolicyIcon)
      }]"
      :icon="icon"
    />
    <Icon
      v-if="showModifier"
      ref="modifierIcon"
      :class="$style.modifier"
      :icon="modifier"
    />
    <CustomIcon
      v-if="isPolicy && !isPolicyIcon"
      :class="$style.shield"
    >
      <svg
        :class="$style.shieldIcon"
        fill="none"
        viewBox="0 0 180 180"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M178 32.6247C177.633 58.0838 169.567 142.578 89.9999 178C10.433
          142.578 2.366 58.4527 2 32.6247L89.9999 2L178 32.6247Z"
          fill="none"
          stroke-linejoin="round"
          stroke-width="var(--icon-border-width)"
        />
      </svg>
    </CustomIcon>
  </div>
</template>

<script>
import { CustomIcon, Icon } from '@jumpcloud/ui-components';

export default {
  name: 'AsideIcon',

  components: {
    CustomIcon,
    Icon,
  },

  props: {
    icon: {
      type: String,
      default: '',
      required: true,
    },
    isPolicy: Boolean,
    modifier: {
      type: String,
      default: '',
    },
    showModifier: Boolean,
  },

  computed: {
    isPolicyIcon() {
      return this.icon === 'policies';
    },
  },
};
</script>

<style scoped module>
.asideIcon {
  --icon-border-width: var(--jc-spacer-x-small);
  --background-color: var(--jc-background);
  --icon-size: var(--jc-size-4);
  --icon-outline-size: 2em;

  align-items: center;
  display: flex;
  font-size: var(--icon-size);
  height: var(--icon-outline-size);
  justify-content: center;
  margin: auto;
  position: relative;
  width: var(--icon-outline-size);
}

.asideIconBorder {
  border: var(--icon-border-width) solid currentColor;
  border-radius: 100%;
}

.iconPolicy {
  position: relative;
  top: -0.11em;
}

.modifier.modifier {
  align-items: center;
  background: var(--background-color);
  border: var(--icon-border-width) solid currentColor;
  border-radius: 100%;
  bottom: var(--jc-spacer-negative-small);
  box-shadow: 0 0 0 var(--icon-border-width) var(--background-color);
  display: flex;
  font-size: 0.333333333em;
  height: 2em;
  justify-content: center;
  position: absolute;
  right: var(--jc-spacer-negative-small);
  width: 2em;
}

.shield.shield {
  align-items: center;
  font-size: var(--icon-outline-size);
  justify-content: center;
  position: absolute;
}

.shieldIcon {
  fill: none;
  stroke: currentColor;
}
</style>
